import { css, styled } from '@mui/material'

export const Container = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => css`
    border-bottom: ${theme.spacing(0.125)} solid ${theme.palette.common.divider};
  `}
`
export const ActionButtonsContainer = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`
